import BorrowerMailbox from './borrower-mailbox';

export default BorrowerMailbox;
